import './LoadingCard.css';

function LoadingCard({width, height}){
    return <div style={{width: width, height: height}} className="loading_card" width={width} height={height}></div>
}

export {LoadingCard};